import BlogSectionRelatedPosts from './BlogSectionRelatedPosts'
import BlogTabs from './BlogTabs'
import { ContainerWrapper } from './Container'
import Header from './Header'
import { footerNavigations } from '../helpers/utils'

function BlogDetailWrapper({
    children,
    title,
    latestBlogPosts,
    initialCategories,
    tags,
    popularPosts,
}) {
    return (
        <div className="space-y-20">
            <ContainerWrapper isHeader={true}>
                <div className="py-4">
                    <Header title={title}></Header>
                </div>
                <div className="flex flex-col lg:flex-row space-y-6 lg:space-y-0">
                    <div className="lg:sticky top-0 lg:h-screen w-full lg:w-80 pt-0 space-y-6 bg-gray-100 py-4 overflow-auto">
                        <div className="font-normal bg-secondary p-4 text-white flex flex-auto justify-between items-center">
                            <h2>FOLLOW:</h2>
                            <div className="flex space-x-1 justify-center">
                                {footerNavigations.social.map((item) => (
                                    <a
                                        target={item.target}
                                        key={item.name}
                                        href={item.href}
                                        id={item?.id}
                                        className="text-white rounded-full hover:underline"
                                        rel="noreferrer">
                                        <span className="sr-only">
                                            {item.name}
                                        </span>
                                        <item.icon
                                            className="h-6 w-6 text-white-light"
                                            aria-hidden="true"
                                        />
                                    </a>
                                ))}
                            </div>
                        </div>
                        <BlogTabs
                            {...{
                                latestBlogPosts,
                                initialCategories,
                                tags,
                                popularPosts,
                            }}
                        />
                    </div>
                    <div className="flex-1 px-4 overflow-auto">{children}</div>
                    <div className="lg:sticky top-0 lg:h-screen w-full lg:w-64 bg-gray-100 space-y-3 overflow-auto mt-4 lg:mt-0">
                        <h2 className="font-normal bg-primary p-4 text-white">
                            MORE
                        </h2>
                        <BlogSectionRelatedPosts
                            initialPage={1}
                            initialPosts={latestBlogPosts}
                            initialCategories={initialCategories}
                            isBlog={true}
                            shouldShowFeaturedPost={false}
                            viewStyle="vertical"
                        />
                    </div>
                </div>
            </ContainerWrapper>
        </div>
    )
}

export default BlogDetailWrapper
